import React from 'react';
import { Form, Input, Button } from 'antd';
import { BuilderSearchReq } from '../../../request/builder.request';
import { useBuilder } from '../builder.hook';

export const BuilderFilterComponent: React.FC = () => {
    const [form] = Form.useForm();
    const { fetchBuilderList, updateLoading, builderSearchReq  } = useBuilder()

    const handleOk = () => {
        form.validateFields().then(values => {
            updateLoading(true);
            const _builderSearchReq = {
                ...builderSearchReq,
                name: values["name"],
                pageNumber: 1,
                itemsPerPage: 10
            } as BuilderSearchReq
            fetchBuilderList(_builderSearchReq, onSuccess, onFailure)
        });
    };

    const onSuccess = () => {
        updateLoading(false);
    }

    const onFailure = () => {
        updateLoading(false);
    }

    return (
        <Form form={form} layout="inline">
            <Form.Item
                name="name"
                style={{ minWidth: 124 }}
                initialValue={builderSearchReq.name}
            >
                <Input placeholder='Name' />
            </Form.Item>

            <Form.Item style={{ minWidth: 124 }}>
                <Button type="primary" htmlType="submit"
                    onClick={handleOk}>
                    Search
                </Button>
            </Form.Item>
        </Form>
    );
}
